global.env = process.env.NODE_ENV;
if (global.env === "production") {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
}
console.log("global.env", global.env);
export const API_DOMAIN =
  global.env === "production" ? "" : "http://localhost:6080";
export const API_URL = `${API_DOMAIN}/api/v1`;

export const moneyBonusFormulas = [
  {
    name: "Công thức 1",
    key: "cong-thuc-1",
    value: [
      { limit: 100, rate: 10 },
      { limit: 200, rate: 20 },
      { limit: 300, rate: 30 },
      { limit: 400, rate: 35 },
      { limit: 500, rate: 35 },
      { limit: 1000, rate: 40 },
      { limit: 2000, rate: 45 },
    ],
  },
  {
    name: "Công thức 2",
    key: "cong-thuc-2",
    value: [
      { limit: 100, rate: 25 },
      { limit: 200, rate: 30 },
      { limit: 300, rate: 35 },
    ],
  },
];
